import classNames from 'classnames';
import React from 'react';

export type CheckboxItemProps = {
    type: 'checkbox' | 'radio';
    tight?: boolean;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'>;

export const CheckboxItem = React.forwardRef<HTMLInputElement, React.PropsWithChildren<CheckboxItemProps>>(
    ({ id, children, type, className, tight, ...props }, ref) => (
        <div className={classNames('relative flex flex-1', className)}>
            <input ref={ref} type={type} className="peer pointer-events-none absolute opacity-0" id={id} {...props} />
            <label
                className={classNames(
                    'hover:ring-primary-300 peer-checked:bg-primary-25 peer-checked:ring-primary-600 peer-focus:shadow-primary-100 group flex-1 cursor-pointer overflow-hidden text-ellipsis rounded bg-white p-2 text-base font-medium text-gray-700 ring-1 ring-gray-200 transition-shadow peer-checked:ring-2 peer-focus:shadow-lg peer-disabled:pointer-events-none peer-disabled:bg-gray-50 peer-disabled:text-gray-400 peer-disabled:opacity-40',
                    { 'sm:p-4': !tight, 'sm:p-3': tight }
                )}
                htmlFor={id}
            >
                {children}
            </label>
        </div>
    )
);
